import {
  Text,
  GreyGrey80,
  Popover,
  Primary13SemiBold,
  Box
} from '@sequencehq/core-components'
import { formatInteger } from '@sequencehq/utils'
import { FC } from 'react'

interface ProgressBarProps {
  label: string
  value: number
  total: number
  color: string
  backgroundColor: string
  tooltip?: React.ReactNode
}

export const ProgressBar: FC<ProgressBarProps> = ({
  label,
  value,
  total,
  color,
  backgroundColor,
  tooltip
}) => {
  return (
    <Box display="flex" flexDirection="column" gap="8px">
      <Text color={GreyGrey80} {...Primary13SemiBold}>
        {label}
      </Text>
      <Popover.Root trigger="hover" placement="right-start">
        <Popover.Trigger>
          <Box
            padding="16px"
            minW={75}
            width={`${(value / total) * 100}%`}
            borderRadius="6px"
            backgroundColor={backgroundColor}
            color={color}
            fontWeight="700"
            borderWidth="1px"
          >
            {formatInteger()(value)}
          </Box>
        </Popover.Trigger>
        {tooltip && <Popover.Content width={250}>{tooltip}</Popover.Content>}
      </Popover.Root>
    </Box>
  )
}
